import * as React from 'react';
import * as copy from 'copy-to-clipboard';

import Icon from './widgets/Icon';

interface Props {
	deployResponse: HasLogfile;
}

function getLogFileProperties(deployResponse: HasLogfile): LogFileProperties {
	if (deployResponse && deployResponse.logfile) {
		return {
			logfile: deployResponse.logfile,
			isCopyDisabled: false,
			isDownloadable: true,
			fileText: 'logfile.txt',
		};
	} else {
		return {
			logfile: 'No logfile provided',
			isCopyDisabled: true,
			isDownloadable: false,
			fileText: 'No logfile',
		};
	}
}

export default class DeployFailure extends React.Component<Props, {}> {

	constructor(props: Props, context: any) {
		super(props, context);
		this.handleCopyLogfileToClipboard = this.handleCopyLogfileToClipboard.bind(this);
	}

	public render() {
		return <div>
			{this.renderFailureLogFileDownload()}
			{this.renderFailureLogFilePreview()}
		</div>;
	}

	private renderFailureLogFileDownload() {
		const {
			logfile,
			isCopyDisabled,
			isDownloadable,
			fileText,
		} = getLogFileProperties(this.props.deployResponse);
		return <div className='log-file-links'>
			<button
				className='log-file-button'
				disabled={isCopyDisabled}
				onClick={this.handleCopyLogfileToClipboard}
			>
				Copy
			</button>
			<div className='file-icon-container'>
				<Icon name='file' fixedWidth />
				<a
					href={`data:text/plain;charset=utf-8, ${encodeURIComponent(logfile)}`}
					download={isDownloadable && fileText}
				>
					<h4>{fileText}</h4>
				</a>
			</div>
		</div>;
	}

	private renderFailureLogFilePreview() {
		return <div className='failure-logfile'>
			<p>{getLogFileProperties(this.props.deployResponse).logfile}</p>
		</div>;
	}

	private handleCopyLogfileToClipboard() {
		const {deployResponse} = this.props;
		if (deployResponse) {
			copy(deployResponse.logfile);
		}
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/DeployFailure.tsx